// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"bf76a8f5","596":"bf76a8f5"}[chunkId] + ".chunk.css";
};